import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-object-nav',
  templateUrl: './object-nav.component.html',
  styleUrls: ['./object-nav.component.less']
})
export class ObjectNavComponent implements OnInit {


  @Input() data: any =[];
  @Input() record = 0;
  @Output() objectChanged =  new EventEmitter<any>();
  current = 1;

  constructor() { }

  ngOnInit() {
  }

  prev() {
    if (this.current != 1) this.current--;
    this.emit();
  }

  next() {
    if (this.current < this.data.length) this.current++;
    this.emit();
  }

  first() {
    this.current = 1;
    this.emit();
  }

  last() {
    this.current = this.data.length;
    this.emit();
  }

  emit() {
    this.objectChanged.emit({ID:this.data[this.current-1].ID, record: this.current});
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes["record"]) {
      if (this.current != changes["record"].currentValue) {
        this.current = changes["record"].currentValue
      }
      return;
    }
    this.current = 1;
  }

}
